<div class="container-fluid m-2 p-2 rounded" [style.backgroundColor]="isProduction()">
  <div class="row center">
    <div class="col-auto ro fs-5 text-center align-middle">
      <a [routerLink]="['/']"> <img class="mt-2" height="60px" src="/assets/img/logo_hospital-logiserve.svg" alt="Logo" /></a>
    </div>
    <div class="col-auto">
      <div class="row">
        <div class="col-auto fs-5 text-center align-middle fw-bold">
          {{ grunddaten.benutzerName() }}
        </div>
        @if (grunddaten.istLogin()) {
          <div class="col-auto d-flex flex-nowrap">
            <kendo-label class="mt-1 me-1" [for]="regulierer" text="Regulierer: "> </kendo-label>
            <kendo-dropdownlist
              #regulierer
              id="regulierer"
              [data]="rlist()"
              textField="bezeichnung"
              valueField="id"
              [filterable]="grunddaten.reguliererList().length > 5"
              (filterChange)="filterRegulierer($event)"
              [popupSettings]="{ width: 'auto' }"
              [valuePrimitive]="true"
              [ngModel]="grunddaten.idRegulierer()"
              (valueChange)="grunddaten.setIdRegulierer($event)"
              [disabled]="grunddaten.sperreRS()"
              [ngClass]="{ rsaktiv: grunddaten.idStation() === 0 }"
            >
            </kendo-dropdownlist>
          </div>
          <div class="col-auto d-flex flex-nowrap">
            <kendo-label class="mt-1 me-1" [for]="station" text="Station: "> </kendo-label>
            <kendo-dropdownlist
              #station
              id="station"
              [data]="slist()"
              textField="bezeichnung"
              valueField="id"
              [filterable]="grunddaten.stationenList().length > 5"
              (filterChange)="filterStation($event)"
              [popupSettings]="{ width: 'auto' }"
              [valuePrimitive]="true"
              [ngModel]="grunddaten.idStation()"
              (valueChange)="grunddaten.setIdStation($event)"
              [disabled]="grunddaten.sperreRS()"
              [ngClass]="{ rsaktiv: grunddaten.idStation() > 0 }"
            >
            </kendo-dropdownlist>
            @if (grunddaten.idStation() > 0) {
              <kendo-svgicon size="xxlarge" [icon]="icons.up" title="Station zurücksetzen" (click)="stationReset()" [ngClass]="grunddaten.sperreRS() ? 'disabled-div' : ''"></kendo-svgicon>
            }
            @if (grunddaten.idStation() === 0 && grunddaten.letzteIdStation() > 0) {
              <kendo-svgicon size="xxlarge" [icon]="icons.down" title="letzte Station aufrufen" (click)="stationLetzte()" [ngClass]="grunddaten.sperreRS() ? 'disabled-div' : ''"></kendo-svgicon>
            }
          </div>
        }
        <div class="col-auto text-center align-middle">
          <button themeColor="success" kendoButton (click)="loginClick()">Anmelden / Wechseln</button>
        </div>
        <div class="col-auto text-center align-middle">
          <button themeColor="error" kendoButton (click)="logoutClick()">Abmelden</button>
        </div>
        <div class="col-auto text-center align-middle">
          <button themeColor="secondary" class="btn-icon-text" kendoButton (click)="hilfeClick()" title="PDF Hilfe">Hilfe <kendo-svg-icon [icon]="icons.pdf" size="medium"></kendo-svg-icon></button>
          @if (pdfVisible()) {
            <kendo-dialog (close)="closePDF()" width="85vw" height="95vh">
              <kendo-dialog-titlebar> PDF-Vorschau </kendo-dialog-titlebar>

              @if (!reportgeneriert()) {
                <ui-spinner></ui-spinner>
              } @else if (hatDaten()) {
                <div style="width: 100%; height: 100%; overflow: hidden">
                  <iframe [src]="pdfUrl" width="100%" height="100%" style="border: none"></iframe>
                </div>
              }

              <kendo-dialog-actions>
                <button kendoButton (click)="closePDF()">Schließen</button>
              </kendo-dialog-actions>
            </kendo-dialog>
          }
        </div>
        <div class="col-auto text-center align-middle">
          <button themeColor="secondary" class="btn-icon-text" kendoButton (click)="videoClick()" title="Video Hilfe">
            Hilfe <kendo-svg-icon [icon]="icons.video" size="medium"></kendo-svg-icon>
          </button>
          @if (videoVisible()) {
            <kendo-dialog (close)="closeVideoHelp()" width="85vw" height="95vh">
              <kendo-dialog-titlebar> Video Hilfe </kendo-dialog-titlebar>

              <app-videos></app-videos>
              <kendo-dialog-actions>
                <button kendoButton (click)="closeVideoHelp()">Schließen</button>
              </kendo-dialog-actions>
            </kendo-dialog>
          }
        </div>
        @if (entwickler()) {
          R: {{ grunddaten.idRegulierer() }} - S: {{ grunddaten.idStation() }}
        }
      </div>

      <div class="mt-2">
        <kendo-menu [items]="sichtbaresMenu()" idField="id" parentIdField="parentId" textField="name" (select)="onSelect($event)">
          <ng-template kendoMenuItemTemplate let-item="item">
            <span style="display: flex; align-items: center; width: 100%; white-space: nowrap">
              <span class="k-menu-link-text">{{ item.text || item.name }}</span>
              @if (item.notificationCount && item.notificationCount > 0) {
                <span class="notification-badge" [class.wichtig]="item.wichtig">{{ item.notificationCount }}</span>
              }
            </span>
          </ng-template>
        </kendo-menu>
      </div>
    </div>
  </div>
</div>

<ui-bestaetigung
  ueberschrift="Prüfung Ihrer persönlichen Stammdaten"
  bezeichnung="Sie werden auf die Seite zur Prüfung Ihrer Stammdaten weitergeleitet."
  [sichtbar]="firmaFehlt()"
  [nurBestaetigung]="true"
  (buttonClick)="checkStammdaten()"
></ui-bestaetigung>

<ui-popup [(wert)]="compNews" title="Aktuelle Neuigkeiten und Informationen"></ui-popup>
